import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { ZuubOnboardingStatusResponse } from '@/@types/zuub/contracts';
import { StatusChip } from '@/common-components/elements/StatusChip/StatusChip';

import { getPayerStatusChipProps } from '../../helpers/helpers';

interface PayerStatusChipProps {
  payerStatus?: ZuubOnboardingStatusResponse;
  isActivelyTesting: boolean;
  isLoading: boolean;
}

export const PayerStatusChip = ({
  payerStatus,
  isActivelyTesting,
  isLoading,
}: PayerStatusChipProps) => {
  if (isLoading) {
    return (
      <div className="vai-w-[156px] vai-flex vai-items-center vai-justify-center">
        <FontAwesomeIcon
          icon={faSpinner}
          className="vai-w-4 vai-h-4 vai-animate-spin vai-text-muted-foreground"
        />
      </div>
    );
  }

  const statusChipProps = getPayerStatusChipProps(
    payerStatus,
    isActivelyTesting,
  );

  return (
    <StatusChip
      text={statusChipProps.text}
      variant={statusChipProps.variant}
      icon={statusChipProps.icon}
      // Standardize with the widest version ("Connection error")
      className="vai-w-[156px] vai-justify-center"
    />
  );
};
